"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeakColor = exports.LeakThreshold = void 0;
var LeakThreshold;
(function (LeakThreshold) {
    LeakThreshold["NoLeak"] = "noLeak";
    LeakThreshold["ExtremelyHumid"] = "extremelyHumid";
    LeakThreshold["HighHumidity"] = "highHumidity";
    LeakThreshold["SlightlyHumid"] = "slightlyHumid";
    LeakThreshold["LeakDetected"] = "leakDetected";
    LeakThreshold["InvalidData"] = "invalidData";
})(LeakThreshold = exports.LeakThreshold || (exports.LeakThreshold = {}));
var LeakColor;
(function (LeakColor) {
    LeakColor["Red"] = "red";
    LeakColor["Yellow"] = "yellow";
    LeakColor["Green"] = "green";
})(LeakColor = exports.LeakColor || (exports.LeakColor = {}));
